export const tableHeaderCategory = (t) => [
    {
      id: 'id',
      type: 'text',
      value: t('cookies:show.table.category.id'),
    },
    {
        id: 'name',
        type: 'text',
        value: t('cookies:show.table.category.cookie'),
    },
    {
        id: 'auto_block',
        type: 'boolean',
        value: t('cookies:show.table.category.autoBlock'),
    },
    {
        id: 'action',
        type: 'actions',
        value: '',
    },
]

export const tableHeaderConsent = (t) => [
    {
        id: 'id',
        type: 'text',
        value: t('cookies:show.table.consent.id'),
    },
    {
        id: 'status',
        type: 'text',
        value: t('cookies:show.table.consent.status'),
    },
    {
        id: 'categories',
        type: 'consent-categories',
        value: t('cookies:show.table.consent.categories'),
    },
    {
        id: 'country',
        type: 'text',
        value: t('cookies:show.table.consent.country'),
    },
    {
        id: 'version',
        type: 'number',
        value: t('cookies:show.table.consent.version'),
    },
    {
        id: 'createdAt',
        type: 'datetime',
        value: t('cookies:show.table.consent.createdAt'),
    }
]
